import type { AdminNavigationSection } from '@/types/adminNavigation';

export const adminNavigationSections: AdminNavigationSection[] = [
  {
    id: 'overview',
    labelKey: 'admin.adminNav.overview',
    sortOrder: 1,
    moduleIds: ['product-management', 'product-menu-management'],
  },
  {
    id: 'configuration',
    labelKey: 'admin.adminNav.configuration',
    sortOrder: 2,
    moduleIds: ['notifications'],
  },
];

export const adminNavigationFooter = {
  nodeLabelKey: 'admin.adminNav.nodeLabel',
  nodeValue: 'US-EAST-01',
  versionLabelKey: 'admin.adminNav.versionLabel',
  versionValue: '4.12.0',
} as const;
